import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import MenuApi from "@/module/Menu/service/missionbadge.js";

import CacheHelper from "@/helper/CacheHelper.js";
import { mapActions } from "vuex";
export default {
    data: function () {
        return {
            mapuserLevelList: {
                16: "gold",
                8: "silver",
                4: "bronze",
            },
            maintainLevelList: {
              524288: "gold",
              262144: "silver",
          },
            birthdayLevel: 1024,
            tiermixin: "",
            pointmixin: "",
            profilemixin: {},
            cacheHelpermixin: new CacheHelper(),
        };
    },
    created() {},
    methods: {
        handleLoading(value) {
            this.$store.commit("Loading", value);
        },
        getUserTier(userlevel) {
            // userlevel = this.originalTier(userlevel);
            // if (userlevel >= 16) {
            //     return "gold";
            // } else if (userlevel >= 8) {
            //     return "silver";
            // } else {
            //     return "bronze";
            // }
             if ((userlevel & 16) == 16 || userlevel == 524288) { 
                 return "gold";
            } else if ((userlevel & 8) == 8 || userlevel == 262144) { 
                return "silver";
            } else {
                return "bronze";
            }
        },
        isMaintainTier(userlevel){
            let ismaintain = false;
            ismaintain = Object.keys(this.maintainLevelList).some(maintainLevel => {
              return userlevel > maintainLevel
            })
              return ismaintain;
        },
        isMaintain(userlevel) {
            let ismaintain = false;
            Object.keys(this.maintainLevelList).forEach(maintainLevel => {
                let currentTier = this.maintainLevelList[maintainLevel]
                if(userlevel > maintainLevel && this.getUserTier(userlevel) == currentTier){
                    ismaintain = true
                } 
              })
              return ismaintain;
        },
        isBirthday(userlevel) {
            let isbirthday = false;
            if (userlevel >= this.birthdayLevel) {
                isbirthday = true;
                return isbirthday;
            }
        },
        calMaintain(userlevel){
          Object.keys(this.maintainLevelList).reverse().forEach(maintainLevel => {
            if(userlevel > maintainLevel){
              userlevel = userlevel - maintainLevel;
            }
          })
          return userlevel
        },
        originalTier(userlevel) {
            if (this.isMaintainTier(userlevel)) {
                userlevel = this.calMaintain(userlevel);
            }
            if (this.isBirthday(userlevel)) {
                userlevel = userlevel - this.birthdayLevel;
            }
            return userlevel
        },
        progressBarCalculate(left) {
            let data = 0;
            let range =
                this.getUserlevel.currentTierRange.to -
                this.getUserlevel.currentTierRange.from;
            data =
                ((this.getUserlevel.point -
                    this.getUserlevel.currentTierRange.from) /
                    range) *
                100;
            if(this.getUserlevel.isMaintain){
                data = (this.getUserlevel.point / this.getUserlevel.currentTierRange.to ) * 100
            }
            if (data >= 100) data = 100;
            if (left && data !== 0) {
                return data - 1;
            }
            return data;
        },
        calcMaintainPosition(){
            let position =  (this.getUserlevel.userLevelMaintain / this.getUserlevel.currentTierRange.to ) * 100
            return { left: position + '%', transform:' translate(-50%)'}
        },
        ...mapActions(["setUserlevel"]),
        getProfile() {
            return new Promise((resolve) => {
                BzbsApi.getProfile(
                    this.cacheHelpermixin.getCache("BzbsUser").token
                ).then((response) => {
                    this.profilemixin = response.data;
                    // this.profilemixin.UserLevel =  524288 + 1024 + 15;
                    this.updatePoint = response.data.updated_points.points;
                    this.getGlassPoint(resolve);
                });
            });
        },
        getGlassPoint(resolveprofile) {
            return new Promise((resolve, reject) => {
                MenuApi.GetMissionBadges().subscribe(
                    (res) => {
                        res.forEach((element) => {
                            if (
                                element.PartitionKey ===
                                "147393556829911_buyitem_BuyPOS"
                            ) {
                                this.pointmixin = element.Missions[0].Current;
                            }
                        });
                        this.checkGlass(resolveprofile);
                        resolve(res);
                    },
                    (err) => {
                        console.log("redeem error", err);
                        reject(err);
                    }
                );
            });
        },
        checkGlass(resolveprofile) {
            // check glass color by piont
            MenuApi.GetUserlevleConfig()
                .then((response) => {
                    this.tiermixin = this.getUserTier(
                        this.profilemixin.UserLevel
                    );
                    let isMaintain = this.isMaintain(
                        this.profilemixin.UserLevel
                    );
                    let currentTierRange =
                        response.data.UserLevel[this.tiermixin];
                    let current = 0;
                    current = currentTierRange.to - this.pointmixin;
                    let title = response.data[this.tiermixin].title.replace(
                        "{x}",
                        current
                    );
                    this.$nextTick(() => {
                        this.setUserlevel({
                            userlevel: this.tiermixin,
                            isMaintain: isMaintain,
                            userLevelMaintain:
                                response.data.UserLevelMaintain[this.tiermixin],
                            point: this.pointmixin,
                            currentTierRange: currentTierRange,
                            title: title,
                            desc: response.data[this.tiermixin].desc,
                            date: response.data[this.tiermixin].date,
                            button: response.data.button,
                        });
                    });
                    resolveprofile();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
